// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"b02c1934","110":"9809fb15","122":"83beb423","283":"68b5a099","393":"cb6c4c3d","453":"9f9083ed","514":"76e68ebb","744":"0e339772"}[chunkId] + ".chunk.js";
};